// src/components/common/ToastContainer.jsx
import React from 'react';

const COLORS = {
  success: { bg: '#193255', border: '#22c55e', icon: '✓' },
  error:   { bg: '#7f1d1d', border: '#ef4444', icon: '✕' },
  warning: { bg: '#78350f', border: '#f59e0b', icon: '⚠' },
  info:    { bg: '#193255', border: '#60a5fa', icon: 'ℹ' },
};

export default function ToastContainer({ toasts }) {
  if (!toasts.length) return null;
  return (
    <div style={{ position:'fixed', top:80, right:20, zIndex:9999, display:'flex', flexDirection:'column', gap:8, maxWidth:380 }}>
      {toasts.map(t => {
        const c = COLORS[t.type] || COLORS.info;
        return (
          <div key={t.id} style={{
            background: c.bg,
            borderLeft: `4px solid ${c.border}`,
            color: '#fff',
            borderRadius: 10,
            padding: '12px 16px',
            fontSize: 13,
            fontWeight: 500,
            boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            animation: 'slideIn 0.2s ease',
          }}>
            <span style={{ fontSize: 16, flexShrink: 0 }}>{c.icon}</span>
            <span>{t.message}</span>
          </div>
        );
      })}
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateX(20px) } to { opacity:1; transform:translateX(0) } }`}</style>
    </div>
  );
}
